import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { RadioCheckList } from 'ui-components/components/radio-check-list';
import { ExportFormatItem } from '../export-format-item';
import { Button } from 'ui-components/components/button';
import { messages as GeneralExportMessages } from '../../messages/general-export-messages';
import { DefaultExportFormat } from '../../enums/default-export-format';
import { DefaultExportFormatOption } from '../default-export-format-option';
import { ExportOptionsValues } from '../../enums/export-options-enum';

import style from '../../export-records-modal.module.less';

export const FormatTypeOptionsGroup = ({
  exportFormats,
  onFormatTypeChanged,
  onCreateNewFormat,
  onDeleteFormat,
  onEditFormat,
  selectedExportFormatTypeId,
  recordExportType,
}) => {
  return (
    <div className={style.group}>
      <div className={style['group-head']}>
        <FormattedMessage {...GeneralExportMessages.exportFormatType} />
        <Button onClick={onCreateNewFormat} theme='tertiary'>
          <FormattedMessage {...GeneralExportMessages.createNewFormat} />
        </Button>
      </div>
      <div className={style['group-options']}>
        <RadioCheckList className={style['radio-button-list']}>
          {exportFormats.map((format) => {
            const isChecked = format.extractId === selectedExportFormatTypeId;
            if (format.extractId === DefaultExportFormat.extractId) {
              return (
                <DefaultExportFormatOption
                  key={format.extractId}
                  format={format}
                  isChecked={isChecked}
                  onFormatTypeChanged={onFormatTypeChanged}
                  recordExportType={recordExportType}
                />
              );
            }
            return (
              <ExportFormatItem
                key={format.extractId}
                format={format}
                isChecked={isChecked}
                onDeleteFormat={onDeleteFormat}
                onEditFormat={onEditFormat}
                onFormatTypeChanged={onFormatTypeChanged}
              />
            );
          })}
        </RadioCheckList>
      </div>
    </div>
  );
};

FormatTypeOptionsGroup.propTypes = {
  exportFormats: PropTypes.array.isRequired,
  onFormatTypeChanged: PropTypes.func.isRequired,
  onCreateNewFormat: PropTypes.func.isRequired,
  onDeleteFormat: PropTypes.func.isRequired,
  onEditFormat: PropTypes.func.isRequired,
  selectedExportFormatTypeId: PropTypes.string.isRequired,
  recordExportType: PropTypes.oneOf(ExportOptionsValues).isRequired,
};
